"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.McpServerResponseModel = void 0;
const core = __importStar(require("../../core"));
const McpServerConfigOutput_1 = require("./McpServerConfigOutput");
const ResourceAccessInfo_1 = require("./ResourceAccessInfo");
const McpServerResponseModelDependentAgentsItem_1 = require("./McpServerResponseModelDependentAgentsItem");
const McpServerMetadataResponseModel_1 = require("./McpServerMetadataResponseModel");
exports.McpServerResponseModel = core.serialization.object({
    id: core.serialization.string(),
    config: McpServerConfigOutput_1.McpServerConfigOutput,
    accessInfo: core.serialization.property("access_info", ResourceAccessInfo_1.ResourceAccessInfo.optional()),
    dependentAgents: core.serialization.property("dependent_agents", core.serialization.list(McpServerResponseModelDependentAgentsItem_1.McpServerResponseModelDependentAgentsItem).optional()),
    metadata: McpServerMetadataResponseModel_1.McpServerMetadataResponseModel,
});
